import { Link } from "react-router-dom";
import { ClipboardList, Phone, MessageCircle } from "lucide-react";
import { SITE } from "../lib/siteConfig";

export default function QuickActions() {
  const wa = `https://wa.me/${SITE.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(
    "Hi CREDNOVA, I would like assistance with a loan enquiry."
  )}`;

  const items = [
    { id: "apply", label: "Get Loan Assistance", sub: "2-min enquiry", icon: ClipboardList, to: "/contact" },
    { id: "call", label: "Call Now", sub: SITE.phone, icon: Phone, href: `tel:${SITE.phone.replace(/\s/g, "")}` },
    { id: "whatsapp", label: "WhatsApp Us", sub: "Chat instantly", icon: MessageCircle, href: wa },
  ];

  return (
    <div className="grid grid-cols-3 gap-3 mt-8 lg:hidden" data-testid="quick-actions">
      {items.map((item) => {
        const inner = (
          <>
            <item.icon size={22} className="text-[#D4AF37] mb-3" strokeWidth={1.5} />
            <span className="text-xs font-medium text-white leading-tight block">{item.label}</span>
            <span className="text-[10px] text-[#71717A] mt-1 block truncate">{item.sub}</span>
          </>
        );
        const cls = "card-gold hover:!transform-none p-4 flex flex-col items-start h-full";
        return item.to ? (
          <Link key={item.id} to={item.to} data-testid={`quick-action-${item.id}`} className={cls}>
            {inner}
          </Link>
        ) : (
          <a
            key={item.id}
            href={item.href}
            data-testid={`quick-action-${item.id}`}
            className={cls}
            {...(item.id === "whatsapp" ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          >
            {inner}
          </a>
        );
      })}
    </div>
  );
}
